export default "__VITE_ASSET__ZSG7jbcH__"